module.exports = __webpack_public_path__ + "static/media/pencil-grey.c559b677.svg";